<template>
  <div class="product pt-[30px]">
    <div class="product__header"></div>
    <ul>
      <li v-for="product in products" :key="product.title">
        <div class="product__title">{{  product.title  }}</div>
        <ul class="product__item__wrapper">
          <li class="product__item" v-for="item in product.list" :key="item.product_no">
            <el-image class="w-[492px] h-[317px]" fit="cover" lazy :src="item.image"></el-image>
            <div class="product__item__info relative flex-1 overflow-hidden">
              <h2 class="product__item__name">{{  item.name  }}</h2>
              <ul class="product__item__tag">
                <li v-for="tag in  item.tags" :key="tag">{{  tag  }}</li>
              </ul>
              <div class="price">
                <span class="price__num">¥{{  item.price  }}</span>
                <span class="price__label">起</span>
              </div>
              <div class="product__item__departure">
                <i class="ficon ficon-dangqianweizhi"></i>
                {{  item.departure  }}出发
              </div>
              <nuxt-link :to="productDetailLink(item.product_type, item.product_no)" target="_blank">
                <el-button class="product__item__btn" color="#C6A14A" round>查看详情</el-button>
              </nuxt-link>
            </div>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>

<script>
import { defineComponent } from "@nuxtjs/composition-api";
import { productDetailLink } from "~/utils/product";


export default defineComponent({
  name: "AdenProduct",
  components: {
  },
  props: {
    products: []
  },
  data() {
    return {

    };
  },
  methods: {
    productDetailLink,
    toDetail(product) {
      return productDetailLink(product.product_type, product.product_no)
    }
  },
})
</script>

<style lang="scss" scoped>
.product__header {
  height: 468px;
  margin-bottom: 90px;
  background: url(~views/topic/202208/aden/imgs/product_bg.png) center no-repeat;
  background-size: auto 468px;
  background-position: center;
}
.product__title {
  font-weight: 700;
  height: 46px;
  font-size: 28px;
  line-height: 1;
  line-height: 46px;
  margin-bottom: 65px;
  text-align: center;
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
  background: url(~views/topic/202208/aden/imgs/product_title_bg.png) center no-repeat;
  background-size: auto 46px;
  background-position: center;
}
.product__item {
  border-radius: 0.125rem;
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  height: 317px;
  margin-left: auto;
  margin-right: auto;
  width: 1099px;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.15);
}
.product__item:not(:last-child) {
  margin-bottom: 10px;
}
.product__item__wrapper {
  margin-bottom: 90px;
}
.product__item__info {
  padding-left: 46px;
  padding-right: 46px;
  padding-top: 30px;
  padding-bottom: 30px;
}
.product__item__name {
  font-size: 24px;
  line-height: 1;
  line-height: 1.5;
  margin-bottom: 20px;
  --tw-text-opacity: 1;
  color: rgba(25, 25, 25, var(--tw-text-opacity));
}
.product__item__tag {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  margin-bottom: 20px;
}
.product__item__tag li {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 240, 226, var(--tw-bg-opacity));
  border-radius: 5px;
  font-size: 1rem;
  line-height: 1.5rem;
  margin-right: 12px;
  margin-bottom: 12px;
  --tw-text-opacity: 1;
  color: rgba(255, 143, 31, var(--tw-text-opacity));
}
.product__item__departure {
  font-size: 1.125rem;
  line-height: 1.75rem;
  --tw-text-opacity: 1;
  color: rgba(25, 25, 25, var(--tw-text-opacity));
}
.product__item__departure .ficon {
  margin-right: 2px;
  --tw-text-opacity: 1;
  color: rgba(147, 147, 147, var(--tw-text-opacity));
}
.product__item__btn {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 143, 31, var(--tw-bg-opacity));
  --tw-border-opacity: 1;
  border-color: rgba(255, 143, 31, var(--tw-border-opacity));
  position: absolute;
  bottom: 30px;
  right: 46px;
}
.product__item__btn ::v-deep span {
  color: white;
}
.price {
  font-weight: 700;
  margin-bottom: 38px;
  --tw-text-opacity: 1;
  color: rgba(25, 25, 25, var(--tw-text-opacity));
}
.price__num {
  font-size: 24px;
  line-height: 1;
}
.price__label {
  font-size: 18px;
  line-height: 1;
}
</style>
